<template>
  <RouterView />
</template>

<script>
import { READ } from '@/plugins/user'
export default {
  data () {
    return {
      title: 'Configuration',
      breadcrumb: {
        name: 'Configuration',
        route: { name: 'configuration' }
      },
      sidebar: [
        {
          hidden: this.$user.cannot(READ, 'dictionary_location'),
          icon: ['fal', 'map-marked-alt'],
          route: { name: 'configuration-locations' },
          name: 'Locations'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.asset),
          icon: ['fal', 'desktop-alt'],
          route: { name: 'configuration-assets' },
          name: 'Assets'
        },
        {
          icon: ['fal', 'bug'],
          route: { name: 'configuration-tracking-error-log' },
          name: 'Tracking Errors'
        },
        {
          icon: ['fal', 'comment-alt-lines'],
          route: { name: 'configuration-tracking-notification-logs' },
          name: 'Tracking Notification Logs'
        },
        {
          icon: ['fal', 'server'],
          route: { name: 'configuration-legacy-workers' },
          name: 'Legacy Workers'
        },
        {
          icon: ['fal', 'exclamation-triangle'],
          route: { name: 'configuration-incidents' },
          name: 'Incidents'
        },
        {
          hidden: true,
          icon: ['fal', 'traffic-cone'],
          route: { name: 'configuration-service-disruptions' },
          name: 'Service Disruptions'
        },
        {
          hidden: true,
          icon: ['fal', 'calendar-day'],
          route: { name: 'configuration-holidays' },
          name: 'Holidays'
        },
        {
          hidden: false,
          icon: ['fal', 'ban'],
          route: { name: 'configuration-blacklist' },
          name: 'Blacklist'
        },
        {
          hidden: true,
          icon: ['fal', 'terminal'],
          route: { name: 'configuration-playground' },
          name: 'SDK Playground'
        }
      ]
    }
  }
}
</script>
